import pushClevertapEvent from 'clevertap/pushClevertapEvent';

export function translateInventoryCode(inventory) {
  switch (inventory) {
    case 1:
    case '1':
      return 'Low Stock Alert';
    case 2:
    case '2':
      return 'Out of Stock Alert';
    default:
      return 'All';
  }
}

export function ingredientLibraryStart({
  outletIds,
  categoryIds,
  InventoryIds,
  totalItems,
}) {
  pushClevertapEvent('Ingredient Library Start', {
    'Current Selected Outlet': outletIds,
    'Current Selected Category': categoryIds,
    'Current Selected Inventory': translateInventoryCode(InventoryIds),
    'Total Ingredients': totalItems,
  });
}

export function ingredientLibraryExport(outletId) {
  pushClevertapEvent('Ingredient Library Export', {
    'Current Selected Outlet': outletId,
  });
}

export function ingredientLibrarySelect({ outletIds, name, category, unit }) {
  pushClevertapEvent('Ingredient Library Update', {
    'Current Selected Outlet': outletIds,
    Name: name,
    Category: category,
    Unit: unit,
  });
}

export function ingredientLibraryCreate({ ingredient, allOutlet }) {
  let eventName = '';
  if (allOutlet) {
    eventName = 'Ingredient Create All Outlet';
  } else {
    eventName = 'Ingredient Create One Outlet';
  }
  pushClevertapEvent(eventName, {
    Name: ingredient.name,
    Category: ingredient.category_name,
    Unit: ingredient.unit_name,
    'In Stock Current': ingredient.in_stock,
  });
}

export function ingredientLibraryDelete({ outletIds, name, category, unit }) {
  pushClevertapEvent('Ingredient Library Delete', {
    'Current Selected Outlet': outletIds,
    Name: name,
    Category: category,
    Unit: unit,
  });
}

export function cogsTrackingIngredient({
  ingredientList,
  libraryCOGSForm,
  showInputCOGS,
}) {
  let eventName = '';
  !showInputCOGS
    ? (eventName = 'COGS Tracking Start Ingredient')
    : (eventName = 'COGS Tracking Manage Ingredient');
  pushClevertapEvent(eventName, {
    'Ingredient [List]': ingredientList,
    Name: ingredientList.name,
    'Average Cost': libraryCOGSForm.cogs,
  });
}

export function libraryIngredientImport({
  eventName,
  selectedOutletIds,
  outlets,
  business,
}) {
  let outletname;
  if (selectedOutletIds.length > 1) {
    outletname = 'All Outlet';
  } else {
    outletname = outlets.reduce(function(filtered, outlet) {
      if (outlet.id === selectedOutletIds[0]) {
        filtered.push(outlet.name);
      }
      return filtered;
    }, []);
  }

  pushClevertapEvent(`Import Ingredient ${eventName}`, {
    'Business Id': business.id,
    'Current Selected Outlet': selectedOutletIds,
    'Outlet Name': selectedOutletIds.length > 1 ? outletname : outletname[0],
  });
}

export function ingredientInventoryFreeTrial({ businessId }) {
  const today = new Date();
  let expiredDate = today.setDate(today.getDate() + 14);
  expiredDate = new Date(expiredDate);
  pushClevertapEvent('Ingredient Inventory Start Free Trial', {
    'Business Id': businessId,
    'Subscribe Expired Date': expiredDate.toLocaleDateString(),
  });
}
